const faqs = [
  {
    q: '黑料在线需要注册才能观看视频吗？',
    a: '不需要。黑料在线采用免注册模式，所有黑料视频均可直接在线观看与在线播放，无需创建账号或登录，打开网站即可畅享全部内容。这也是我们区别于其他平台的核心优势之一。',
  },
  {
    q: '黑料在线的视频内容更新频率如何？',
    a: '我们每日更新超过200条黑料视频正片，覆盖网红爆料、明星八卦、综艺揭秘、MCN深挖等多元题材。运营团队全天候追踪热点事件，确保用户在第一时间获取最新黑料大瓜，满足黑料在线观看需求。',
  },
  {
    q: '黑料在线视频播放画质如何？会有广告吗？',
    a: '所有黑料视频均提供高清画质在线播放，加载速度快且无卡顿。平台严格过滤弹窗广告和恶意跳转，全程清爽观影体验。黑料在线免费观看无需付费，也没有强制观看广告的环节。',
  },
  {
    q: '如何联系黑料在线进行内容投稿或商务合作？',
    a: '欢迎通过下方"联系我们"区域与我们取得联系。如果您有独家爆料素材或希望进行黑料内容投稿，也可以直接发送至我们的工作邮箱。我们高度重视用户来稿，并对投稿人信息严格保密。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于黑料在线的常见问题与解答
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg flex-shrink-0">Q{i + 1}</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}